<template>
  <div class="customer-address" v-loading="loading">
    <el-row :gutter="20" type="flex" align="top" style="flex-wrap: wrap">
      <el-col :xl="12" :lg="12" :md="12" :sm="24" :xs="24" v-for="item in addressList" :key="item.id">
        <el-card class="address-card">
          <div class="line-item">
            <div class="line-left">{{ $t('customer::customer-list::recipient') }}：</div>
            <!-- <div class="content">{{ item.firstName + ' ' + item.lastName }}</div> -->
            <div class="content">{{ item.userName }}</div>
          </div>
          <div class="line-item">
            <div class="line-left">{{ $t('customer::customer-list::address') }}：</div>
            <div class="content" style="word-break: break-all">
              <!-- {{ item.country }} {{ item.province }} {{ item.city }} {{ item.address1 }} {{ item.address2 }} -->
              {{ item.address }}
            </div>
          </div>
          <div class="line-item">
            <div class="line-left">{{ $t('customer::customer-list::email') }}：</div>
            <div class="content">{{ item.userEmail }}</div>
          </div>
          <div class="line-item">
            <div class="line-left">{{ $t('customer::customer-list::phone') }}：</div>
            <div class="content">{{ item.phone }}</div>
          </div>
          <!-- <div class="address-btn">
            <div class="address-use" v-if="item.tag === 1" @click="setDefault(item)">
              <p style="top: -26px;right: -15px;">
                {{ $t('customer::customer-list::often') }}{{ $t('customer::customer-list::use') }}
              </p>
            </div>
            <div class="address-edit" v-else>
              <el-checkbox @change="setDefault(item)">
                {{ $t('customer::customer-list::set_commonly_used_addr') }}
              </el-checkbox>
            </div>
          </div> -->
        </el-card>
      </el-col>
      <el-col :span="24" v-if="addressList.length === 0">
        <el-card>
          <div style="text-align: center">{{ $t('customer::customer-list::no_deliver_addr') }}</div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { setDefaultAddress } from '@/server/customers'
import { getCustomerAddress } from '@/server/etl'
export default {
  name: 'tab-address',
  data() {
    return {
      loading: false,
      addressList: [],
    }
  },
  activated() {
    this.getAddress()
  },
  computed: {
    merchantId() {
      return this.$store.state.user.merchantId
    },
  },
  methods: {
    async getAddress() {
      this.loading = true
      const { data } = await getCustomerAddress({
        orgUnitId: this.merchantId,
        userEmail: this.$route.params.email,
      })
      this.loading = false
      if (data.code === this.$code) {
        this.addressList = data.data.datas
      }
    },
    async setDefault(item) {
      this.loading = true
      const tag = item.tag === 1 ? 0 : 1
      const { data } = await setDefaultAddress(item.id, tag)
      this.loading = false
      if (data.code === this.$code) {
        this.getAddress()
        this.$message.success(this.$t('customer::customer-list::setting_success'))
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.address-card {
  padding: 8px;
  position: relative;
  margin-bottom: 20px;
  .line-item {
    display: flex;
    .line-left {
      width: 60px;
      text-align: right;
      margin-right: 8px;
    }
    .content {
      color: #666;
      flex: 1;
    }
  }
  .line-item + .line-item {
    margin-top: 16px;
  }
  .address-btn {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 1;
    .address-use {
      position: relative;
      color: #fff;
      border-top-right-radius: 5px;
      box-sizing: border-box;
      width: 0;
      height: 0;
      border: 22px solid transparent;
      border-top: 22px solid #0560fd;
      border-right: 22px solid #0560fd;
      cursor: pointer;
    }
    .address-use::after {
      content: '常用';
      font-weight: bold;
      font-size: 12px;
      width: 40px;
      position: absolute;
      top: -10px;
      transform: rotateZ(45deg);
      left: -6px;
    }
    .address-edit {
      padding: 24px 24px 0 0;
    }
  }
}
</style>
